export default __webpack_public_path__ + "static/media/system_02_06.dd661bce.jpg";